/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const SignalLow = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M2 20h.01" }],
    ["path", { d: "M7 20v-4" }]
  ]
];

export { SignalLow as default };
//# sourceMappingURL=signal-low.js.map
